var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0917 15.9083L14 12.8417C15.2001 11.3454 15.7812 9.44609 15.624 7.53443C15.4668 5.62276 14.5831 3.844 13.1546 2.56388C11.7261 1.28377 9.8615 0.599604 7.9441 0.652071C6.0267 0.704538 4.20226 1.48965 2.84595 2.84596C1.48963 4.20228 0.704522 6.02671 0.652055 7.94411C0.599588 9.86152 1.28375 11.7262 2.56387 13.1546C3.84398 14.5831 5.62275 15.4668 7.53441 15.624C9.44608 15.7813 11.3453 15.2001 12.8417 14L15.9083 17.0667C15.9858 17.1448 16.078 17.2068 16.1795 17.2491C16.2811 17.2914 16.39 17.3132 16.5 17.3132C16.61 17.3132 16.7189 17.2914 16.8205 17.2491C16.922 17.2068 17.0142 17.1448 17.0917 17.0667C17.2419 16.9113 17.3258 16.7036 17.3258 16.4875C17.3258 16.2714 17.2419 16.0637 17.0917 15.9083ZM8.16666 14C7.01294 14 5.88512 13.6579 4.92584 13.0169C3.96655 12.3759 3.21888 11.4649 2.77737 10.399C2.33585 9.3331 2.22034 8.16021 2.44542 7.02865C2.6705 5.8971 3.22607 4.8577 4.04187 4.04189C4.85768 3.22608 5.89708 2.67051 7.02864 2.44543C8.16019 2.22035 9.33308 2.33587 10.399 2.77738C11.4649 3.21889 12.3759 3.96657 13.0169 4.92585C13.6579 5.88514 14 7.01295 14 8.16668C14 9.71377 13.3854 11.1975 12.2915 12.2915C11.1975 13.3854 9.71376 14 8.16666 14Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsearch);
export default __webpack_public_path__ + "static/media/iconsearch.d056db9d34893044fa1eed49264386e5.svg";
export { ForwardRef as ReactComponent };